import { useState } from "react";
import { Brain, X, Send } from "lucide-react";
import { VoiceButton } from "./VoiceButton";

// Floating brain-dump button (bottom-left). Tap anywhere to offload a thought
// by voice or text; it's filed as a task instantly.
export const BrainDumpButton = ({ onCreate }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");

  const save = () => {
    const t = text.trim();
    if (!t) return;
    onCreate(t, "voice");
    setText("");
    setOpen(false);
  };

  return (
    <>
      {open && (
        <div className="fixed bottom-24 left-6 z-50 w-[320px] max-w-[calc(100vw-3rem)] border shadow-2xl"
          style={{ backgroundColor: "var(--dash-card)", borderColor: "var(--dash-border)" }}
          data-testid="brain-dump-panel">
          <div className="flex items-center justify-between p-3 border-b" style={{ borderColor: "var(--dash-border)" }}>
            <div className="flex items-center gap-2">
              <Brain size={16} className="text-[#8b5cf6]" />
              <span className="font-heading text-xs uppercase tracking-[0.15em]" style={{ color: "var(--dash-text)" }}>Brain dump</span>
            </div>
            <button onClick={() => setOpen(false)} data-testid="brain-dump-close" className="text-zinc-500 hover:text-white bg-transparent border-none cursor-pointer">
              <X size={16} />
            </button>
          </div>
          <div className="p-3 space-y-3">
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Get it out of your head… tap the mic and just talk."
              data-testid="brain-dump-input"
              className="w-full h-24 bg-transparent border p-2 outline-none font-body text-sm resize-none"
              style={{ color: "var(--dash-text)", borderColor: "var(--dash-border)" }}
              autoFocus
            />
            <div className="flex items-center justify-between">
              <VoiceButton
                onText={(t) => setText((p) => (p ? p + " " : "") + t.trim())}
                size={22}
                testId="brain-dump-voice-btn"
                title="Speak your thought"
                className="w-11 h-11 border border-[#8b5cf6]/40 text-[#8b5cf6] rounded-full"
              />
              <button onClick={save} data-testid="brain-dump-save"
                className="flex items-center gap-2 px-4 py-2.5 text-xs uppercase font-body bg-[#8b5cf6] text-white border-none cursor-pointer">
                <Send size={14} /> Capture
              </button>
            </div>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="brain-dump-fab"
        title="Brain dump"
        className="fixed bottom-6 left-6 z-50 w-14 h-14 rounded-full flex items-center justify-center border-none cursor-pointer shadow-2xl transition-transform hover:scale-105"
        style={{ backgroundColor: "#8b5cf6", color: "#fff" }}
      >
        <Brain size={24} />
      </button>
    </>
  );
};

export default BrainDumpButton;
